import { render, staticRenderFns } from "./switch-picker.vue?vue&type=template&id=117ab3e1&scoped=true"
import script from "./switch-picker.vue?vue&type=script&lang=js"
export * from "./switch-picker.vue?vue&type=script&lang=js"
import style0 from "./switch-picker.vue?vue&type=style&index=0&id=117ab3e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ab3e1",
  null
  
)

export default component.exports